import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import webSocketService from '../../services/WebSocketService';
import { WEBSOCKET_NOTIFICATION_CONTAINER_ID } from './notificationToastConfig';

const disableNotificationHotKeys = () => false;

const WebSocketNotificationToastContainer = ({ isAuthenticated }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isAuthenticated) return undefined;

    // The Toastify store is discarded with this container. Clear the matching
    // service records as well so a later login cannot inherit priority or
    // replay ownership from the previous authenticated session.
    return () => webSocketService.clearNotificationVisualState();
  }, [isAuthenticated]);

  if (!isAuthenticated) return null;

  return (
    <ToastContainer
      containerId={WEBSOCKET_NOTIFICATION_CONTAINER_ID}
      position="top-center"
      className="mobile-toast-offset"
      limit={1}
      newestOnTop={false}
      hotKeys={disableNotificationHotKeys}
      aria-label={t('notifications')}
    />
  );
};

export default WebSocketNotificationToastContainer;
